'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _imagesloaded = require('imagesloaded');

var _imagesloaded2 = _interopRequireDefault(_imagesloaded);

var _zoom = require('./zoom');

var _zoom2 = _interopRequireDefault(_zoom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var propTypes = {
	alt: {
		type: 'string'
	},
	class: {
		type: 'string'
	},
	delay: {
		type: 'number'
	},
	itemprop: {
		type: 'string'
	},
	src: {
		type: 'string'
	},
	zoom: {
		type: 'string'
	}
};

var defaultProps = {
	alt: '',
	delay: 0,
	itemprop: '',
	src: '',
	zoom: ''
};

var afterRender = function afterRender(_ref, el) {
	var props = _ref.props;
	return (0, _imagesloaded2.default)(el, function () {
		return (0, _zoom2.default)(el.querySelector('.InlineZoom-image'), props.delay);
	});
};
var shouldUpdate = function shouldUpdate(_ref2, nextProps) {
	var props = _ref2.props;
	return !(0, _deepEqual2.default)(props, nextProps);
};

var afterUpdate = function afterUpdate(_ref3) {
	var id = _ref3.id;

	var zoom = document.querySelector('.InlineZoom--' + id + ' .InlineZoom-zoomed');

	if (!zoom) {
		return;
	}

	zoom.src = '';
};

var render = function render(_ref4) {
	var id = _ref4.id,
	    props = _ref4.props;
	var alt = props.alt,
	    itemprop = props.itemprop,
	    src = props.src,
	    zoom = props.zoom;

	var style = {
		display: 'inline-block',
		overflow: 'hidden',
		position: 'relative'
	};

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['InlineZoom', 'InlineZoom--' + id, props.class], style: 'margin: auto;' },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': 'InlineZoom-listener', style: style },
			(0, _magicVirtualElement2.default)('img', { 'class': 'InlineZoom-image', src: src, alt: alt, itemprop: itemprop }),
			(0, _magicVirtualElement2.default)('img', { 'class': 'InlineZoom-zoomed', 'data-src': zoom })
		)
	);
};

exports.default = { afterUpdate: afterUpdate, afterRender: afterRender, defaultProps: defaultProps, propTypes: propTypes, render: render, shouldUpdate: shouldUpdate };